import Controller from '../abstracts/Controller';
import 'scss-templates/t-service-page.scss';

export default class ServicePageController extends Controller {
  static get COMPONENTS() {
    return [
    ];
  }
}
